import React, { Component } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import compareArrays from '../../../helpers/compareArrays'

export default class FormIsRequiredField extends Component {
  constructor (props) {
    super(props)

    this.onChange = props.onChange

    this.state = {
      value: this.props.isRequired
    }

    this.toggle = this.toggle.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    return this.state.value !== nextState.value || compareArrays(this.props.newIndexes, nextProps.newIndexes)
  }

  toggle () {
    this.setState({
      value: !this.state.value
    }, () => {
      this.onChange({ value: this.state.value, indexes: this.props.newIndexes, field: 'isRequired' })
    })
  }

  render () {
    return (
      <FontAwesomeIcon
        className={['is-required', this.state.value ? 'required' : 'not-required'].join(' ')}
        icon='asterisk'
        onClick={this.toggle}
      />
    )
  }
}
